import React from 'react';

const PageIndicator = ({ currentPage, totalPages, pageTitle, showTotal = false }) => {
  const fmt = (n) => String(n).padStart(2, '0');

  return (
    <footer className="py-6 px-4">
      <div className="flex flex-col items-center gap-2">
        {pageTitle && (
          <div className="text-[1.1rem] font-semibold tracking-wide uppercase text-foreground">
            {pageTitle}
          </div>
        )}

        <div className="flex justify-center items-center gap-3">
          {/* Dots — only when showing total */}
          {showTotal && totalPages && (
            <div className="flex items-center gap-2">
              {Array.from({ length: totalPages }, (_, index) => (
                <div
                  key={index}
                  className={`h-2 rounded-full transition-all duration-300 ${
                    index + 1 === currentPage
                      ? 'w-8 bg-accent'
                      : 'w-2 bg-muted-foreground/30'
                  }`}
                />
              ))}
            </div>
          )}

          {/* Text indicator */}
          <div className={`text-base font-medium tracking-wide text-muted-foreground ${showTotal ? 'ml-4' : ''}`}>
            Page <span className="text-foreground font-semibold">{fmt(currentPage)}</span>
            {showTotal && totalPages && (
              <> of <span className="text-foreground font-semibold">{fmt(totalPages)}</span></>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};

export { PageIndicator };
export default PageIndicator;
